import React from 'react'
import { Field } from 'react-final-form'

import Text from 'Components/UI/Text'

import { HiddenRadio, RadioContainer, RadioPoint, StyledRadio } from './styles'

type Props = {
  label?: string
  name: string
  value?: string
}

function RadioButton({ label, name, value, ...props }: Props) {
  return (
    <Field name={name} type="radio" value={value}>
      {({ input: { checked, onChange: handleChange, type } }) => (
        <RadioContainer {...props} checked={checked} onClick={handleChange}>
          <HiddenRadio name={name} type={type} value={value} />

          <StyledRadio checked={checked}>
            <RadioPoint />
          </StyledRadio>

          {label && <Text>{label}</Text>}
        </RadioContainer>
      )}
    </Field>
  )
}

export default RadioButton
